<template xmlns:v-clipboard="http://www.w3.org/1999/xhtml">
    <div id="code" class="guanzhu">
        <div class="guanzhu" v-show="alert">
            <p class="p1">未完待续...</p>
            <p class="p2">页面篇幅有限，点击下方<span>“复制公众号”</span>按钮，打开微信搜索公众号即可继续阅读全文哦~</p>
            <p class="p3">请认准官方唯一认证公众号</p>
            <p class="p4">{{wechat.nickname}}</p>
            <button
                    v-clipboard:copy="wechat.search||wechat.nickname"
                    v-clipboard:success="copySuccess"
                    v-clipboard:error="copyError">一键复制</button>

            <img src="./../assets/images/1.gif" alt="">
        </div>
        <div class="success" v-show="success">
            <p>复制成功</p>
            <a href="weixin://">公众号ID已复制，请打开微信添加关注公众号并回复"c{{$route.params.id}}"继续阅读</a>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import VueClipboard from 'vue-clipboard2'
    Vue.use(VueClipboard)
    export default {
        name: "Code",
        data (){
            return {
                wechat : {},
                success : false,
                alert : true,
                pv : true,
            }
        },
        methods : {
            getViewChapter(){
                this.axios.post('/api/chapter/getViewChapterCode',{
                    id : this.$route.params.id
                }).then(r => {
                    let data =r.data;
                    if(data.code){
                        this.wechat = data.data
                    }
                })
            },
            copySuccess(){
                if(this.pv){
                    this.pv = false;
                    // this.axios.post('/api/link/addPv',{
                    //     id : this.$route.params.id
                    // }).then(r => {
                    //     console.log(r.data);
                    // })
                }

                window.location.href='weixin://'
            },
            copyError(){
                alert("复制失败");
            }
        },
        created() {
            this.getViewChapter();
        }
    }
</script>

<style lang="less">
#code{overflow: auto;
    .top{height: 400px;}
    .content{margin: 40px 0;padding: 0 20px;
        h4{font-size: 36px;text-align: center;color: #333;}
        p{font-size: 30px;line-height: 50px;margin-bottom: 20px;color: #666;}
    }
    .btn{text-align: center;
        button{background: orangered;color: #fff;font-size: 30px;width: 200px;height: 60px;border: none;border-radius: 60px;}
    }
    .wechat{text-align: center;padding: 40px;
        span{color: orangered;}
    }
    .guanzhu{position: fixed;top: 20px;left : 20px;right:20px;bottom: 20px;background: #fff;text-align: center;box-shadow: 0 0 20px #fff;z-index: 999;
        padding: 40px;overflow: auto;
        .p1,.p2{font-size: 40px;color: orange;margin-bottom: 40px;
            span{color: orangered;}
        }

        .p3{font-size: 36px;color: orangered;}
        .p4{font-size: 40px;color: #13ce66;line-height: 100px;}
        button{background: orangered;border: none;color: #fff;width: 200px;height: 60px;border-radius: 60px;}

        img{width: 100%;margin-top: 40px;}

    }
    .success{font-size:30px;position: fixed;top: 0px;left : 0px;right:0px;bottom: 0px;z-index: 99999;background: #fff;height: 300px;margin: auto;text-align: center;padding: 80px 0 0;box-shadow: 0 0 60px #000;
        a{background: orangered;color: #fff;padding: 10px;line-height: 60px;}
        p{margin-bottom: 20px;}
    }
}
</style>
